/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StaffCouponLastActionDto } from './staffCouponLastActionDto';
import { BoughtCouponDto } from './boughtCouponDto';


export interface StaffCouponRowDto { 
    loyaltyCouponUuid?: string;
    coupon?: BoughtCouponDto;
    liveStatus?: StaffCouponRowDto.LiveStatusEnum;
    source?: StaffCouponRowDto.SourceEnum;
    scanCount?: number;
    firstScannedAt?: string;
    lastAction?: StaffCouponLastActionDto;
}
export namespace StaffCouponRowDto {
    export type LiveStatusEnum = 'ACTIVE' | 'EXPIRED' | 'REDEEMED' | 'TO_BE_REDEEMED' | 'CANCELLED';
    export const LiveStatusEnum = {
        Active: 'ACTIVE' as LiveStatusEnum,
        Expired: 'EXPIRED' as LiveStatusEnum,
        Redeemed: 'REDEEMED' as LiveStatusEnum,
        ToBeRedeemed: 'TO_BE_REDEEMED' as LiveStatusEnum,
        Cancelled: 'CANCELLED' as LiveStatusEnum
    };
    export type SourceEnum = 'STAFF_SCAN' | 'CUSTOMER_TIMER';
    export const SourceEnum = {
        StaffScan: 'STAFF_SCAN' as SourceEnum,
        CustomerTimer: 'CUSTOMER_TIMER' as SourceEnum
    };
}


